export function common() {
  const header = document.getElementById("js-header");

  const headerScroll = () => {
    if (header) {
      window.addEventListener("scroll", () => {
        if (window.scrollY > 1 && window.innerWidth > 768) {
          header.classList.add("is-scroll");
        } else {
          header.classList.remove("is-scroll");
        }
      });
    }
  };

  headerScroll();
}

// アコーディオンの開閉時にフェードアウトアニメーションを適用する
document.querySelectorAll(".c-accordion summary").forEach((summary) => {
  summary.addEventListener("click", (event) => {
    const accordion = event.currentTarget.closest(".c-accordion");
    if (accordion) {
      const parentItem = accordion.closest(".p-top-point__item");

      // 状態を切り替える前に判定
      const isOpen = accordion.hasAttribute("open");

      // クリック時にクラスの付け外しを調整
      if (parentItem) {
        if (isOpen) {
          parentItem.classList.add("is-fading-out");
        } else {
          parentItem.classList.remove("is-fading-out");
        }
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  // single-program.php 用の処理
  if (typeof php_vars !== 'undefined' && php_vars.experienceLevel) {
    const starsContainer = document.querySelector(".c-experienceStars");
    if (starsContainer) {
      starsContainer.innerHTML = ""; // 既存の星をクリア

      // 動的に星を生成
      for (let i = 1; i <= 3; i++) {
        const starElement = document.createElement("span");
        starElement.classList.add("c-experienceStars__star");
        starElement.setAttribute("data-value", i);

        if (i <= php_vars.experienceLevel) {
          starElement.style.backgroundImage = `url('${php_vars.starIcon}')`;
        } else {
          starElement.style.backgroundImage = `url('${php_vars.starIconLite}')`;
        }

        starsContainer.appendChild(starElement);
      }
    }
  }

  // front-page.php 用の処理
  if (typeof php_vars !== 'undefined' && php_vars.postsData) {
    php_vars.postsData.forEach(function (postData) {
      const starsContainer = document.querySelector(
        `.c-experienceStars[data-post-id="${postData.postId}"]`
      );
      if (starsContainer) {
        starsContainer.innerHTML = ""; // 既存の星をクリア

        // 動的に星を生成
        for (let i = 1; i <= 3; i++) {
          const starElement = document.createElement("span");
          starElement.classList.add("c-experienceStars__star");
          starElement.setAttribute("data-value", i);

          if (i <= postData.experienceLevel) {
            starElement.style.backgroundImage = `url('${postData.starIcon}')`;
          } else {
            starElement.style.backgroundImage = `url('${postData.starIconLite}')`;
          }

          starsContainer.appendChild(starElement);
        }
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const tableBody = document.querySelector('#table-body');
  if (tableBody) {
    const periodCell = document.querySelector('.c-scroll-table__data'); // ２泊３日のセル
    if (periodCell) {
      // テーブルの行数をカウント
      const rowCount = tableBody.querySelectorAll('.c-scroll-table__tr').length;

      // rowCountに基づいて `rowspan` を設定
      periodCell.setAttribute('rowspan', rowCount);
    }
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const rows = document.querySelectorAll(".c-scroll-table__tr");

  rows.forEach((row, rowIndex) => {
    const firstCell = row.querySelector(".c-scroll-table__data._1");

    if (firstCell && firstCell.textContent.trim() !== "") {
      let rowspanCount = 1;

      // 次の行以降を確認し、最初の列が空かどうかを確認
      for (let i = rowIndex + 1; i < rows.length; i++) {
        const nextRow = rows[i];
        const nextCell = nextRow.querySelector(".c-scroll-table__data._1");

        // 次のセルが空かどうか確認
        if (nextCell && nextCell.textContent.trim() === "") {
          rowspanCount++;
          nextCell.style.display = "none"; // 空のセルは非表示にする
        } else {
          break; // 空でないセルが現れたらループを終了
        }
      }

      // rowspanを設定（2つ以上空セルがあれば適用）
      if (rowspanCount > 1) {
        firstCell.setAttribute("rowspan", rowspanCount);
      }
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const rows = document.querySelectorAll("#table-body .c-scroll-table__tr"); // tbody 内の行のみを対象にする

  rows.forEach((row) => {
    const cells = row.querySelectorAll(".c-scroll-table__data");

    // 全てのセルが空かどうかを確認
    let allCellsEmpty = true;
    cells.forEach(cell => {
      if (cell.textContent.trim() !== "") {
        allCellsEmpty = false; // 1つでも空でないセルがあれば false にする
      }
    });

    // 全てのセルが空なら行を非表示にする
    if (allCellsEmpty) {
      row.style.display = "none";
    }
  });
});



$(function () {
  let el2 = {}; // アコーディオン2用のオブジェクト

  el2.accordion = ".js-accordion2"; // アコーディオン2のセレクタを変更
  el2.accordionMoreContent = ".js-accordionMoreContent";
  el2.accordionButton = ".js-accordionButton";
  el2.accordionButtonText = ".js-accordionButtonText";
  el2.accordionContent = ".c-accordion2__content";
  el2.isActive = "is-active";
  el2.slideSpeed = 200;

  // アコーディオン2の開閉処理
  $(el2.accordionButton).on("click", function () {
    const parentAccordion = $(this).closest(el2.accordion);

    // アコーディオンの内容をスライドさせる
    parentAccordion.find(el2.accordionMoreContent).slideToggle(el2.slideSpeed);

    // ボタンとコンテンツに is-active クラスを切り替える
    $(this).toggleClass(el2.isActive);
    parentAccordion.find(el2.accordionButtonText).toggleClass(el2.isActive);
    parentAccordion.find(el2.accordionContent).toggleClass(el2.isActive);
  });
});
